import { Card } from '../ui/Card'
import { WidgetHeader } from './WidgetKommende'

interface VacantLease {
  unitNo: string
  vacantSinceDays: number
  vacantSince: string
}

interface WidgetTomgangProps {
  vacantLeases: VacantLease[]
  loading: boolean
  editMode?: boolean
}

export function WidgetTomgang({ vacantLeases, loading, editMode }: WidgetTomgangProps) {
  return (
    <Card
      padding="none"
      style={editMode ? { border: '1.5px dashed #4f46e5', background: '#fafbff' } : undefined}
    >
      <WidgetHeader title="Lejemål i tomgang" />
      <div style={{ padding: '10px 16px' }}>
        {loading ? (
          <div style={{ color: '#94a3b8', fontSize: 12 }}>Henter…</div>
        ) : vacantLeases.length === 0 ? (
          <div style={{
            padding: '12px 8px', background: '#f8fafc', borderRadius: 6,
            textAlign: 'center', color: '#94a3b8', fontSize: 12,
          }}>
            Ingen tomgangslejemål
          </div>
        ) : (
          vacantLeases.map((l, i) => (
            <div
              key={l.unitNo}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: 8,
                padding: '6px 0',
                borderBottom: i < vacantLeases.length - 1 ? '1px solid #f8fafc' : 'none',
              }}
            >
              <div style={{
                width: 6, height: 6, borderRadius: '50%',
                background: '#dc2626', marginTop: 4, flexShrink: 0,
              }} />
              <div>
                <div style={{ color: '#0f172a', fontSize: 12, fontWeight: 500 }}>{l.unitNo}</div>
                <div style={{ color: '#94a3b8', fontSize: 11 }}>
                  Ledig siden {l.vacantSince}
                  {l.vacantSince !== '—' && ` · ${l.vacantSinceDays} ${l.vacantSinceDays === 1 ? 'dag' : 'dage'}`}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </Card>
  )
}
